module.exports = __webpack_public_path__ + "static/img/phone.b2abe37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/phone.svg
// module id = nOah
// module chunks = 0